import { StatisticalAnalysisDelayAndResponseEnum } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticalAnalysisDelaysAndResponseTimeDetailState {
    timeSheetId: Nullable<StatisticalAnalysisTimesheetItems>
    selection: Nullable<StatisticalAnalysisDelayAndResponseEnum>
}
export const initialStatisticalAnalysisDelaysAndResponseTimeDetailState =
    (): StatisticalAnalysisDelaysAndResponseTimeDetailState => ({
        selection: null,
        timeSheetId: null
    })
